var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4 0.895431 4.89543 0 6 0H10C11.1046 0 12 0.895431 12 2V4H15C15.5523 4 16 4.44772 16 5V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V5C0 4.44771 0.447715 4 1 4H4V2ZM6 2H10V4H6V2ZM2 7C2 6.44772 2.44769 6 3 6C3.55231 6 4 6.44772 4 7V13C4 13.5523 3.55231 14 3 14C2.44769 14 2 13.5523 2 13V7ZM12 7C12 6.44772 12.4477 6 13 6C13.5523 6 14 6.44772 14 7V13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13V7Z",
    fill: "#00A19B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfessional);
export default __webpack_public_path__ + "static/media/icon-professional.100d5effdb45b0dee3c88221041cf48c.svg";
export { ForwardRef as ReactComponent };